var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillIconsTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 0H11.7188C5.24666 0 0 5.24666 0 11.7188V38.2812C0 44.7533 5.24666 50 11.7188 50H38.2812C44.7533 50 50 44.7533 50 38.2812V11.7188C50 5.24666 44.7533 0 38.2812 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 0H11.7188C5.24666 0 0 5.24666 0 11.7188V38.2812C0 44.7533 5.24666 50 11.7188 50H38.2812C44.7533 50 50 44.7533 50 38.2812V11.7188C50 5.24666 44.7533 0 38.2812 0Z",
    fill: "#1D9BF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9789 17.8537C39.0004 18.1637 39.0004 18.4736 39.0004 18.7865C39.0004 28.3172 31.7449 39.309 18.4779 39.309V39.3031C14.5586 39.3088 10.7205 38.1863 7.42188 36.0697C7.9918 36.1383 8.56445 36.1725 9.13867 36.1738C12.3871 36.1764 15.5421 35.0869 18.0967 33.0803C16.5916 33.0518 15.1329 32.5538 13.9248 31.6557C12.7166 30.7577 11.8192 29.5045 11.3582 28.0715C12.4388 28.2798 13.5528 28.2373 14.6145 27.9473C11.2496 27.2674 8.82871 24.3109 8.82871 20.8773V20.7859C9.83182 21.3446 10.9545 21.6542 12.1021 21.6887C8.93301 19.5705 7.95605 15.3543 9.86973 12.0578C11.6805 14.2861 13.9398 16.1086 16.5009 17.4068C19.0619 18.7051 21.8674 19.45 24.7352 19.5934C24.4492 18.3626 24.4915 17.0783 24.8576 15.8689C25.2238 14.6596 25.9011 13.5676 26.8217 12.7021C29.7268 9.97128 34.2957 10.1113 37.0266 13.0148C38.6418 12.6959 40.1908 12.1038 41.6068 11.2639C41.0684 12.9339 39.9416 14.3515 38.4361 15.2529C39.8659 15.0845 41.2623 14.7017 42.5781 14.1176C41.6102 15.5672 40.3913 16.8323 38.9789 17.8537Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillIconsTwitter);
export default __webpack_public_path__ + "static/media/skill-icons_twitter.51f3d4f9173e771de6188a9c7a249515.svg";
export { ForwardRef as ReactComponent };